import Vue from "vue/dist/vue.esm";
import Vuex from "vuex";
import user from "/store/user";
import header from "/store/header";
import search from "/store/search";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    header,
    search
  }
});

export const modules = { user, header, search };
